import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmSubjectType } from '../interfaces/IKnmSubjectType';

export async function fetchKnmSubjectTypes(): Promise<IKnmSubjectType[]> {
  return apiGet<IKnmSubjectType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-subject-types`);
}
